'use client'

import { Button, type ButtonProps } from '@/components/primitives/Button/Button'
import { handleLogin } from '@/lib/auth/login'

export const LoginButton = ({ children, ...props }: ButtonProps) => {
  return (
    <Button {...props} onClick={handleLogin}>
      {children}
    </Button>
  )
}
